import { ConversationDetails } from "@virtualprogaming/js-public-sdk";
import React, { FC, useCallback, useState } from "react";

import {
  useChatRenameConversation,
  useChatUpdateSystemConversation,
} from "~/queries";
import { Icon, LoadingIcon, TextInput } from "~/ui/components";
import { useChatAuthAccessToken, useChatToRename } from "~/ui/context";
import { useCurrentUser } from "~/utils";

export const ConversationRename: FC<{
  conversation: ConversationDetails;
  isGlobal: boolean;
}> = ({ conversation, isGlobal = false }) => {
  const {
    mutateAsync: renameConversation,
    isLoading,
  } = useChatRenameConversation();
  const {
    mutateAsync: renameConversationSystem,
    isLoading: isSystemConversationUpdating,
  } = useChatUpdateSystemConversation();
  const { setChatToRename } = useChatToRename();
  const accessToken = useChatAuthAccessToken();
  const currentUser = useCurrentUser();
  const [name, setName] = useState<string>(conversation?.display_name ?? "");

  const rename = useCallback(() => {
    if (!conversation.id) return;
    if (name === conversation?.display_name) return setChatToRename(null);

    if (isGlobal && currentUser?.user_id === 3) {
      renameConversationSystem([
        conversation.id,
        name,
        conversation?.description ?? "",
        undefined,
        conversation?.tags ?? [],
      ]).then(() => {
        setChatToRename(null);
      });
    } else {
      renameConversation([conversation.id, accessToken, name]).then(() => {
        setChatToRename(null);
      });
    }
  }, [
    accessToken,
    conversation,
    currentUser,
    isGlobal,
    name,
    renameConversation,
    renameConversationSystem,
    setChatToRename,
  ]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      rename();
    }
  };
  return (
    <div className="flex items-center justify-between w-90 gap-xs pd-sm pd-b-xs pointer bg-gold">
      <TextInput
        wrapperClassname="bg-gold w-90"
        className="w-100"
        value={name}
        autoFocus
        onChange={(e) => setName(e.target.value as string)}
        onKeyDown={handleKeyDown}
      />
      {isLoading || isSystemConversationUpdating ? (
        <LoadingIcon
          size="1x"
          className="pointer h-30px w-30 pd-l-sm pd-r-sm flex items-center bg-success justify-center borderR-1 text-black mg-r-md "
        />
      ) : (
        <Icon
          onClick={rename}
          icon={["fal", "pen"]}
          size="1x"
          className="pointer h-30px w-30 pd-l-sm pd-r-sm flex items-center bg-success justify-center border-light borderR-1 text-black mg-r-md "
        />
      )}
    </div>
  );
};
